import { Box, Grid, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../api/app/commonApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { useTranslation } from '../../contexts/translation';
import { AppInfo } from '../../types/app/appInfo.types';
import { useStyles } from './appInfo.styles';
interface Props {
  title: string;
  data?: string;
}

const InfoPageRow = ({ title, data }: Props) => {
  const classes = useStyles();
  return (
    <Grid container item spacing={3} className={classes.container}>
      <Grid item xs={5}>
        <Typography variant={'body1'}>{title}</Typography>
        <Box mr={3} />
      </Grid>
      <Grid item xs={7}>
        <Typography variant={'body1'} color={'secondary'} className={classes.bold}>
          {data}
        </Typography>
      </Grid>
    </Grid>
  );
};

export const InfoPage = () => {
  const { t } = useTranslation();
  const [appName, setAppName] = useState<string>('');
  const { data, isLoading, isError } = useQuery<AppInfo>('AppInfo', api.getAppInfo);
  const classes = useStyles();

  useEffect(() => {
    if (!data) return;
    let text = '';
    let appNameArr = data?.appName.split('.');
    appNameArr.map((t: string) => (text += ' ' + t));
    setAppName(text);
  }, [data]);

  if (isError) return <ApiError />;
  if (isLoading || !data) return <Loader />;

  return (
    <Grid container direction={'column'} justifyContent={'flex-start'} alignItems={'center'}>
      <Grid item>
        <Box mt={5} />
        <Typography variant={'h4'} className={classes.heading} style={{ textAlign: 'center' }}>
          {/* {data?.appName} */}
          {appName}
        </Typography>
        <Box mb={3} />
      </Grid>
      <Grid item>
        <Typography variant={'h5'}>{data?.author}</Typography>
      </Grid>
      <Grid item container direction={'row'} spacing={4} justifyContent={'center'}>
        <Grid item>
          <Typography variant={'body1'}>{data?.authorContactEmail}</Typography>
        </Grid>
        <Grid item>
          <Typography variant={'body1'}>{data?.authorContactMobile}</Typography>
          <Box mb={5} />
        </Grid>
      </Grid>
      <Grid item container direction={'row'} justifyContent={'center'}>
        <Box mt={5} />
        <Paper>
          <Box px={5} py={2} className={classes.botContainer}>
            <Grid container spacing={2} direction={'column'}>
              <InfoPageRow title={t('page.app-info.info-text-1')} data={data?.version} />
              <InfoPageRow title={t('page.app-info.info-text-2')} data={data?.versionDate} />
              <InfoPageRow title={t('page.app-info.info-text-3')} data={data?.database} />
              <InfoPageRow
                title={t('page.app-info.info-text-4')}
                data={data?.databaseServerVersion}
              />
              <InfoPageRow title={t('page.app-info.info-text-5')} data={data?.environmentName} />
              <InfoPageRow title={t('page.app-info.info-text-6')} data={data?.machineName} />
              <InfoPageRow title={t('page.app-info.info-text-7')} data={data?.appPool} />
            </Grid>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
